import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-searchresult-list',
    styleUrl: 'sew-ws-searchresult-list.scss',
    shadow: false,
})
export class SewWsSearchresultList {
    @Prop() headline: string;

    render() {
        return (
            <Host>
                <div class="main-content-container">
                    <div>
                        <h2 class="headline" innerHTML={this.headline}></h2>
                        <div class="items">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
